import { render } from "./TopBarPublic.vue?vue&type=template&id=473a3dba"
import script from "./TopBarPublic.vue?vue&type=script&lang=js"
export * from "./TopBarPublic.vue?vue&type=script&lang=js"

import exportComponent from "G:\\desarrollo\\frontend\\gsobservatorio-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__